import ymaps, { IGeoObject, IPointGeometry } from 'yandex-maps'

export interface CreatePolygonParamsI {
    coordinates: number[][]
    color: string
    hintContent: string | null
}

export default function () {
    function generateRandomHex(): string {
        return Math.floor(Math.random() * 16777215).toString(16)
    }

    function createPoint(
        coordinates: number[],
        options: Record<string, any>,
        properties: Record<string, any>
    ): ymaps.Placemark {
        return new window.ymaps.Placemark(coordinates, options, properties)
    }

    function createCluster(options?: ymaps.IClustererOptions): any {
        return new window.ymaps.Clusterer(options)
    }

    // polygons
    function createPolygon({ coordinates, color, hintContent }: CreatePolygonParamsI) {
        return new window.ymaps.Polygon(
            [coordinates],
            { hintContent },
            {
                strokeOpacity: 0.7,
                strokeWidth: 2,
                fillOpacity: 0.4,
                strokeColor: color,
                fillColor: color,
                zIndexHover: 0,
                // draggable: true,
            }
        )
    }

    return { generateRandomHex, createPoint, createCluster, createPolygon }
}
